module.exports = __webpack_public_path__ + "static/media/hotal.17540ee4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/hotal.jpg
// module id = 1930
// module chunks = 108